/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';

// Redux
import { useSelector } from 'react-redux';

// Material
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// Helpers

// Constants

// Types
import { ApplicationState } from 'store';

// Styles
import useStyle from './taxesNavigation.styles';

interface TransactionNavigationProps {
  setTableReference: (arg: any) => void;
  headerTaxes: Array<any>;
}

type Props = TransactionNavigationProps;

const TaxesNavigation: React.FC<Props> = ({
  setTableReference,
  headerTaxes,
}) => {
  const classes = useStyle();

  const [ordersWithTaxes, setOrdersWithTaxes] = useState<any>([]);

  const initialCompanyReportList = useSelector(
    (state: ApplicationState) => state.companies.companyReportList,
  );

  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );

  const transportOperatorsList = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorsList,
  );

  useEffect(() => {
    if (initialCompanyReportList?.length > 0) {
      const tempOrdersWithTaxes = initialCompanyReportList
        ?.map((order) => {
          if (order?.Taxes?.length! > 0) {
            return order;
          }

          return null;
        })
        .filter(Boolean);

      if (tempOrdersWithTaxes?.length > 0) {
        setOrdersWithTaxes(tempOrdersWithTaxes);
      } else {
        setOrdersWithTaxes([]);
      }
    }
  }, [initialCompanyReportList]);

  return (
    <TableContainer
      className={classes.tableContainer}
      ref={(ref: any) => setTableReference(ref)}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell variant='head' align='center'>
              ID
            </TableCell>
            <TableCell variant='head' align='center'>
              Valor Pedido
            </TableCell>

            {headerTaxes?.length > 0
              ? headerTaxes?.map((tax) => (
                  // eslint-disable-next-line react/jsx-indent
                  <TableCell variant='head' align='center'>
                    {tax}
                  </TableCell>
                ))
              : null}

            <TableCell variant='head' align='center'>
              Valor Pago
            </TableCell>
            {transportOperatorSelected.type === 1 && (
              <TableCell variant='head' align='center'>
                Operação
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {ordersWithTaxes?.length > 0 &&
            ordersWithTaxes?.map((request: any) => {
              let finalOrderValue = request?.value ?? 0;

              return (
                <TableRow style={{ padding: 16 }} key={request.id}>
                  <TableCell align='center'>
                    {' '}
                    {request?.id ? request?.id?.split('-')[0] : '---'}{' '}
                  </TableCell>
                  <TableCell align='center'>
                    {' '}
                    {request?.value
                      ? `R$ ${request?.value?.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                        })}`
                      : '---'}
                  </TableCell>

                  {headerTaxes?.length > 0
                    ? headerTaxes?.map((tax) => {
                        const taxValue = request?.Taxes?.find(
                          (item: any) => item.name === tax,
                        )?.value;

                        const decimalTaxValue = (taxValue ?? 0) / 100;
                        const taxAmount =
                          (request?.value ?? 0) * decimalTaxValue;
                        finalOrderValue -= taxAmount;

                        return (
                          // eslint-disable-next-line react/jsx-indent
                          <TableCell align='center'>
                            {taxValue
                              ? ` R$ ${taxAmount?.toLocaleString('pt-BR', {
                                  minimumFractionDigits: 2,
                                })} `
                              : '---'}
                          </TableCell>
                        );
                      })
                    : null}

                  <TableCell align='center'>
                    {finalOrderValue > 0
                      ? `R$ ${finalOrderValue?.toLocaleString('pt-BR', {
                          minimumFractionDigits: 2,
                        })}`
                      : '---'}
                  </TableCell>
                  {transportOperatorSelected.type === 1 && (
                    <TableCell>
                      {transportOperatorsList.find(
                        (e) => e.id === request?.transportOperatorId,
                      )?.name || '---'}
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export { TaxesNavigation };
export default TaxesNavigation;
